import { useState, useEffect, useRef } from 'react'
import { useInactivityGuard } from './store/inactivity.js'
import { useTheme, useA11y, useIsMobile } from './store/theme.js'
import { useGlobalProducts } from './store/products.js'
import { iniciarPolling, setProductsRef, subAvisos, getAvisos, marcarAvisoLido, limparAvisos, subSyncStatus, getSyncStatus } from './store/omieSync.js';import LoginScreen from './components/shared/LoginScreen.jsx'
import StockModule from './components/stock/StockModule.jsx'

function App(){
  const consultandoRef = useRef(false);
  const [dark,toggleTheme]=useTheme();
  const [a11y,toggleA11y]=useA11y();
  const mobile=useIsMobile();
  const [user,setUser]=useState(null);
  const [products,setProducts]=useGlobalProducts();
  const [avisos,setAvisos]=useState(()=>getAvisos());
  const [syncInfo,setSyncInfo]=useState(()=>getSyncStatus());
  useEffect(()=>subAvisos(setAvisos),[]);
  useEffect(()=>subSyncStatus(setSyncInfo),[]);
  const [showAvisos,setShowAvisos]=useState(false);
  const [module,setModule]=useState("stock");
  const [sideOpen,setSideOpen]=useState(true);

  useEffect(()=>{setProductsRef(products);},[products]);
  useEffect(()=>{
    const unsub=subAvisos(setAvisos);
    iniciarPolling();
    return unsub;
  },[]);

  const avisosNaoLidos=avisos.filter(a=>!a.lido).length;

  const logout=()=>{setUser(null);setModule("stock");setSideOpen(true);};
  const { warning, countdown, nightMode, dismiss } = useInactivityGuard(user, logout);

  if(!user)return <LoginScreen onLogin={u=>{setUser(u);setModule("stock");}} dark={dark} toggleTheme={toggleTheme}/>;

  // ── Role meta ──────────────────────────────────────────────────────────────
  const ROLE_META={
    operator:   {label:"⚙ OPERADOR",   color:"#ffa502"},
    consultant: {label:"◎ CONSULTOR",  color:"#00d084"},
    entregador: {label:"⊕ ENTREGADOR", color:"#3b82f6"},
    licita_op:      {label:"⚖ OPERADOR LIC.",  color:"#a78bfa"},
    licita_captacao: {label:"◉ CAPTAÇÃO",       color:"#38bdf8"},
    licita_cotacao:  {label:"◈ COTAÇÃO",         color:"#fbbf24"},
    licita_disputa:  {label:"⚡ DISPUTA",         color:"#f97316"},
    licita_pospreg:  {label:"◎ PÓS-PREGÃO",      color:"#34d399"},
    licita_dash:     {label:"▣ DASHBOARD",        color:"#818cf8"},
  };
  const roleMeta=ROLE_META[user.role]||ROLE_META.consultant;

  // ── Nav items per role ─────────────────────────────────────────────────────
  // ── FASE ATUAL: apenas módulo ESTOQUE ativo ──────────────────────────────
  // Os demais módulos estão em desenvolvimento e serão desbloqueados por fase.
  const navItems=[
    {id:"stock",icon:"▣",label:"ESTOQUE"},
    // {id:"logistics",  icon:"◈", label:"LOGISTICA"}   — fase 2
    // {id:"demandas",   icon:"◎", label:"DEMANDAS"}    — fase 2
    // {id:"entregas",   icon:"⊕", label:"ENTREGAS"}    — fase 2
    // {id:"licitacoes", icon:"⚖", label:"LICITAÇÕES"}  — fase 3
  ];


  // ══════════════════════════════════════════════════════════════════════════
  // MOBILE LAYOUT — top tabs
  // ══════════════════════════════════════════════════════════════════════════
  if(mobile) return(
    <div style={{display:"flex",flexDirection:"column",height:"100vh",background:"var(--bg)",overflow:"hidden"}}>

      {/* Mobile top bar */}
      <header style={{background:"var(--bg2)",borderBottom:"1px solid var(--border)",flexShrink:0,paddingTop:"env(safe-area-inset-top,0px)"}}>
        {/* Brand + actions row */}
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 14px"}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:18,color:"#ffa502"}}>▣</span>
            <div>
              <div style={{fontSize:11,fontWeight:700,letterSpacing:3,color:"var(--text)",lineHeight:1}}>ESTOQUE<span style={{color:"#ffa502"}}>OS</span></div>
              <div style={{fontSize:7,letterSpacing:2,color:"var(--text4)"}}>CROMA</div>
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:8,letterSpacing:1,padding:"3px 7px",border:`1px solid ${roleMeta.color}44`,borderRadius:2,background:roleMeta.color+"18",color:roleMeta.color,whiteSpace:"nowrap"}}>
              {roleMeta.label}
            </span>
            {nightMode&&<span style={{fontSize:7,letterSpacing:1,padding:"2px 6px",border:"1px solid #a78bfa44",borderRadius:2,background:"#a78bfa12",color:"#a78bfa"}}>⏻</span>}
            <button onClick={toggleTheme} style={{background:"none",border:"1px solid var(--border2)",color:"var(--text3)",padding:"5px 8px",fontSize:10,cursor:"pointer",borderRadius:2,minHeight:32}}>
              {dark?"☀":"●"}
            </button>
            {user.role==="operator"&&<SyncPill info={syncInfo} compact/>}
            <button onClick={logout} style={{background:"none",border:"1px solid var(--border2)",color:"var(--text4)",padding:"5px 8px",fontSize:9,letterSpacing:1,cursor:"pointer",borderRadius:2,minHeight:32}}>SAIR</button>          </div>
        </div>
        {/* Top tabs */}
        <div style={{display:"flex",borderTop:"1px solid var(--border)",overflowX:"auto"}}>
          {navItems.map(n=>(
            <button key={n.id} onClick={()=>setModule(n.id)}
              style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:3,padding:"8px 4px",background:"none",border:"none",borderBottom:module===n.id?"2px solid #ffa502":"2px solid transparent",color:module===n.id?"#ffa502":"var(--text4)",cursor:"pointer",fontSize:8,letterSpacing:1,fontFamily:"'Courier New',monospace",whiteSpace:"nowrap",minWidth:60,position:"relative"}}>
              <span style={{fontSize:16}}>{n.icon}</span>
              {n.label}
              {n.badge>0&&<span style={{position:"absolute",top:4,right:"calc(50% - 18px)",background:"#ff4757",color:"#fff",fontSize:7,padding:"1px 4px",borderRadius:99,fontWeight:700,lineHeight:1.4}}>{n.badge}</span>}
            </button>
          ))}
        </div>
      </header>

      {/* Content */}
      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column",paddingBottom:"env(safe-area-inset-bottom,0px)"}}>
        <StockModule user={user} products={products} setProducts={setProducts}/>
      </div>

      {warning&&<InactivityModal countdown={countdown} onDismiss={dismiss}/>}
    </div>
  );

  // ══════════════════════════════════════════════════════════════════════════
  // DESKTOP LAYOUT — sidebar
  // ══════════════════════════════════════════════════════════════════════════
  return(
    <div style={{display:"flex",height:"100vh",background:"var(--bg)",overflow:"hidden"}}>
      {/* Sidebar */}
      <div style={{width:sideOpen?190:48,background:"var(--bg2)",borderRight:"1px solid var(--border)",display:"flex",flexDirection:"column",flexShrink:0,overflow:"hidden",transition:"width .15s"}}>
        <div style={{padding:sideOpen?"14px 14px 12px":"14px 0 12px",borderBottom:"1px solid var(--border)",display:"flex",alignItems:"center",gap:10,justifyContent:sideOpen?"flex-start":"center"}}>
          <span style={{fontSize:20,color:"#ffa502",flexShrink:0}}>▣</span>
          {sideOpen&&<div>
            <div style={{fontSize:12,fontWeight:700,letterSpacing:3,color:"var(--text)",lineHeight:1}}>ESTOQUE<span style={{color:"#ffa502"}}>OS</span></div>
            <div style={{fontSize:7,letterSpacing:3,color:"var(--text4)",marginTop:2}}>CROMA</div>
          </div>}
        </div>
        <nav style={{flex:1,padding:"10px 0"}}>
          {navItems.map(n=>(
            <button key={n.id} onClick={()=>setModule(n.id)}
              style={{width:"100%",display:"flex",alignItems:"center",gap:10,padding:sideOpen?"9px 14px":"9px 0",justifyContent:sideOpen?"flex-start":"center",background:module===n.id?"#ffa50215":"none",border:"none",borderLeft:module===n.id?"2px solid #ffa502":"2px solid transparent",color:module===n.id?"#ffa502":"var(--text4)",cursor:"pointer",fontSize:9,letterSpacing:2,fontFamily:"'Courier New',monospace",whiteSpace:"nowrap"}}>
              <span style={{fontSize:14,flexShrink:0,position:"relative"}}>
                {n.icon}
                {!sideOpen&&n.badge>0&&<span style={{position:"absolute",top:-4,right:-6,background:"#ff4757",color:"#fff",fontSize:7,padding:"1px 3px",borderRadius:99,fontWeight:700,lineHeight:1.4}}>{n.badge}</span>}
              </span>
              {sideOpen&&<span style={{display:"flex",alignItems:"center",gap:6}}>
                {n.label}
                {n.badge>0&&<span style={{background:"#ff4757",color:"#fff",fontSize:8,padding:"1px 5px",borderRadius:99,fontWeight:700,lineHeight:1.4}}>{n.badge}</span>}
              </span>}
            </button>
          ))}
        </nav>
        <div style={{borderTop:"1px solid var(--border)"}}>
          <button onClick={()=>setSideOpen(v=>!v)} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",padding:"10px",background:"none",border:"none",color:"var(--text4)",cursor:"pointer",fontSize:14}}>
            {sideOpen?"◁":"▷"}
          </button>
        </div>
      </div>

      {/* Main area */}
      <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",minWidth:0}}>
        {/* Header */}
        <header style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 16px",borderBottom:"1px solid var(--border)",background:"var(--bg2)",flexShrink:0,gap:8,flexWrap:"wrap"}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:9,letterSpacing:2,padding:"2px 8px",border:`1px solid ${roleMeta.color}44`,borderRadius:2,background:roleMeta.color+"18",color:roleMeta.color}}>
              {roleMeta.label}
            </span>
            <span style={{fontSize:9,color:"var(--text4)"}}>{user.name}</span>
            {nightMode&&<span style={{fontSize:7,letterSpacing:1,padding:"2px 7px",border:"1px solid #a78bfa44",borderRadius:2,background:"#a78bfa12",color:"#a78bfa"}}>⏻ MODO SEGURO</span>}
          </div>
          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
            {user.role==="operator"&&<SyncPill info={syncInfo}/>}
            {user.role==="operator"&&<button onClick={()=>setShowAvisos(v=>!v)}
              style={{position:"relative",background:showAvisos?"#ffa50220":"none",border:`1px solid ${avisosNaoLidos>0?"#ffa50255":"var(--border2)"}`,color:avisosNaoLidos>0?"#ffa502":"var(--text4)",padding:"5px 10px",fontSize:9,letterSpacing:2,cursor:"pointer",borderRadius:2}}>
              AVISOS
              {avisosNaoLidos>0&&<span style={{position:"absolute",top:-4,right:-4,background:"#ff4757",color:"#fff",fontSize:7,padding:"1px 4px",borderRadius:99,fontWeight:700,lineHeight:1.4}}>{avisosNaoLidos}</span>}
            </button>}
            {/* SyncClock e DEMANDAS — fase 2 */}
            <button onClick={toggleTheme} style={{background:"none",border:"1px solid var(--border2)",color:"var(--text3)",padding:"5px 10px",fontSize:9,letterSpacing:2,cursor:"pointer",borderRadius:2}}>
              {dark?"☀ CLARO":"● ESCURO"}
            </button>
            <button onClick={toggleA11y} style={{background:a11y?"#a78bfa22":"none",border:`1px solid ${a11y?"#a78bfa88":"var(--border2)"}`,color:a11y?"#a78bfa":"var(--text4)",padding:"5px 10px",fontSize:9,letterSpacing:2,cursor:"pointer",borderRadius:2,lineHeight:1}}>
              ✱ ACESSIBILIDADE
            </button>
            <button onClick={logout} style={{background:"none",border:"1px solid var(--border2)",color:"var(--text4)",padding:"5px 10px",fontSize:9,letterSpacing:2,cursor:"pointer",borderRadius:2}}>SAIR</button>
          </div>
        </header>

        {/* Module content */}
        <StockModule user={user} products={products} setProducts={setProducts}/>
      </div>

      {showAvisos&&<AvisosPanel avisos={avisos} onClose={()=>setShowAvisos(false)} onMarcarLido={marcarAvisoLido} onMarcarTodosLidos={()=>avisos.forEach(a=>marcarAvisoLido(a.id))} onLimpar={()=>{limparAvisos();setShowAvisos(false);}}/>}
      {warning&&<InactivityModal countdown={countdown} onDismiss={dismiss}/>}
    </div>
  );
}

function SyncPill({info,compact}){
  const _minsAgo=ts=>{
    if(!ts)return null;
    return Math.floor((Date.now()-new Date(ts).getTime())/60000);
  };
  const mins=_minsAgo(info?.lastTs);
  const s=info?.status;
  const label=s==='syncing'?'SINCRONIZANDO':
               s==='error'?'SYNC ERRO':
               mins!=null?`SYNC ${mins}min`:'AGUARDANDO';
  const color=s==='syncing'?'#ffa502':s==='error'?'#ff4757':'var(--text5)';
  const border=s==='syncing'?'#ffa50244':s==='error'?'#ff475733':'var(--border2)';
  if(compact&&s==='idle'&&mins!=null&&mins<2)return null; // no mobile, oculta se recente
  return(
    <span style={{fontSize:7,letterSpacing:1,padding:'2px 7px',border:`1px solid ${border}`,borderRadius:2,color,fontFamily:"'Courier New',monospace",whiteSpace:'nowrap'}}>
      {label}
    </span>
  );
}

function AvisosPanel({avisos,onClose,onMarcarLido,onMarcarTodosLidos,onLimpar}){
  const naoLidos=avisos.filter(a=>!a.lido).length;
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",display:"flex",zIndex:1000}} onClick={onClose}>
      <div style={{background:"var(--bg2)",borderLeft:"1px solid var(--border2)",width:"100%",maxWidth:420,height:"100vh",overflowY:"auto",marginLeft:"auto",paddingBottom:"env(safe-area-inset-bottom,0px)"}} onClick={e=>e.stopPropagation()}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"18px 20px",borderBottom:"1px solid var(--border)",position:"sticky",top:0,background:"var(--bg2)",zIndex:10}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:11,letterSpacing:3,color:"#ffa502",fontWeight:700}}>AVISOS</span>
            {naoLidos>0&&<span style={{background:"#ff4757",color:"#fff",fontSize:9,padding:"2px 7px",borderRadius:99,fontWeight:700}}>{naoLidos}</span>}
          </div>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            {naoLidos>0&&<button onClick={onMarcarTodosLidos} style={{background:"none",border:"1px solid #ffa50244",color:"#ffa502",padding:"3px 8px",fontSize:8,letterSpacing:1,cursor:"pointer",borderRadius:2}}>MARCAR TODOS LIDOS</button>}
            {avisos.length>0&&<button onClick={onLimpar} style={{background:"none",border:"1px solid #ff475744",color:"#ff4757",padding:"3px 8px",fontSize:8,letterSpacing:1,cursor:"pointer",borderRadius:2}}>APAGAR TUDO</button>}
            <button style={{background:"none",border:"none",color:"var(--text3)",fontSize:18,cursor:"pointer"}} onClick={onClose}>✕</button>
          </div>
        </div>
        <div style={{padding:"16px 20px"}}>
          {avisos.length===0&&(
            <div style={{textAlign:"center",padding:"60px 0"}}>
              <div style={{fontSize:36,color:"var(--border2)",marginBottom:12}}>◎</div>
              <p style={{color:"var(--text5)",fontSize:11,letterSpacing:2}}>NENHUM AVISO</p>
            </div>
          )}
          {avisos.map(a=>(
            <div key={a.id} onClick={()=>onMarcarLido(a.id)}
              style={{background:a.lido?"var(--bg)":"var(--bg3)",border:`1px solid ${a.cor||"#ffa502"}${a.lido?"22":"44"}`,borderRadius:2,padding:14,marginBottom:10,cursor:a.lido?"default":"pointer",opacity:a.lido?0.6:1}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,marginBottom:6}}>
                <p style={{fontSize:10,color:a.cor||"#ffa502",fontWeight:700,letterSpacing:1}}>{a.titulo}</p>
                {!a.lido&&<span style={{fontSize:8,color:"#ffa502",flexShrink:0}}>● novo</span>}
              </div>
              <p style={{fontSize:11,color:"var(--text2)"}}>{a.mensagem}</p>
              <p style={{fontSize:9,color:"var(--text5)",marginTop:6}}>{a.ts?new Date(a.ts).toLocaleString("pt-BR"):""}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function InactivityModal({countdown, onDismiss}){
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999}}>
      <div style={{background:"var(--bg2)",border:"1px solid #a78bfa44",borderRadius:2,padding:"32px 28px",maxWidth:340,width:"90%",textAlign:"center"}}>
        <div style={{fontSize:28,color:"#a78bfa",marginBottom:12}}>⏻</div>
        <p style={{fontSize:9,letterSpacing:3,color:"#a78bfa",marginBottom:8}}>MODO SEGURO</p>
        <p style={{fontSize:11,color:"var(--text2)",marginBottom:6}}>Inatividade detectada fora do horário comercial.</p>
        <p style={{fontSize:10,color:"var(--text3)",marginBottom:20}}>Logout automático em</p>
        <div style={{fontSize:40,fontWeight:700,fontFamily:"monospace",color:countdown<=10?"#ff4757":countdown<=30?"#ffa502":"var(--text)",marginBottom:24,lineHeight:1}}>
          {String(countdown).padStart(2,"0")}s
        </div>
        <button onClick={onDismiss} style={{background:"#a78bfa",border:"none",color:"#fff",padding:"10px 28px",fontSize:9,letterSpacing:2,cursor:"pointer",borderRadius:2,fontFamily:"'Courier New',monospace",width:"100%"}}>
          CONTINUAR SESSÃO
        </button>
      </div>
    </div>
  );
}

export default App